/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Check_MandatoryInputs */

const cs_portals_check_mandatory = /** @type {(inputs: Portals_Check_MandatoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Povinné`)
};

const en_portals_check_mandatory = /** @type {(inputs: Portals_Check_MandatoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Required`)
};

/**
* | output |
* | --- |
* | "Required" |
*
* @param {Portals_Check_MandatoryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_check_mandatory = /** @type {((inputs?: Portals_Check_MandatoryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Check_MandatoryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_check_mandatory(inputs)
	return cs_portals_check_mandatory(inputs)
});